module.exports = "/_next/static/images/d85b98cfd5340e5dc0dd9d9c6784ea5d-mb-hero-xs-experiment.jpg.webp";